import React from 'react'
import "./knowMoreButton.scss"
interface props {
    buttons: any
  }
const KnowMoreButton = ({buttons}:props) => <button className='knowMoreButton' onClick={()=>buttons("PortfolioFilter")} >Know More</button>

export default KnowMoreButton